export default __webpack_public_path__ + "static/header-logo-378df6c1a1b69a6c3499ad801fbba1cd.svg";